import axios from 'axios';
// client use
// const baseURL = 'http://targettest.asktek.net/tompg.naturaloffice.testing.webapi/api/';

// testing 
const baseURL ='http://targettest.asktek.net/tompg.naturaloffice.windows.testing.webapi/api/';

// For Mobile Testing Vm ware 
// const baseURL='https://live.asktek.net/tompg.naturaloffice.windows.testing.webapi/api/'

// const baseURL= "http://192.168.1.50:8089/api/"

// Client UAT For Indent Concept 
// const baseURL ='http://targetdemo.asktek.net/tompg.naturaloffice.indent.uat.webapi/api/';

// Live 
// const baseURL ='https://live.asktek.net/tompg_naturaloffice_webapi/api/';

// Local 
// const baseURL= "http://localhost:8089/api/"

// const baseURL= "http://localhost:8089/api/"
//const baseURL= "http://desktop-o3684s3:8089/api/"
const instance = axios.create({
  baseURL,
});

export default {
  instance,
  baseURL,
};
